import React from 'react'

export function increaseLegibilityForLabel(label: string, wordBreakThreshold = 12): string | React.ReactNode[] {
  // Implement your legibility enhancement logic here
  if (typeof label !== 'string') {
    return label
  }
  const wordBreaks = Array.from(label).reduce(
    (acc, char, index) => {
      if (/\s/.test(char)) {
        acc.nonSpaceCount = 0
        return acc
      }
      if (acc.nonSpaceCount >= wordBreakThreshold) {
        acc.wordBreaks.push(index)
        acc.nonSpaceCount = 1
      } else {
        acc.nonSpaceCount++
      }
      return acc
    },
    { wordBreaks: [], nonSpaceCount: 0 } as { wordBreaks: number[]; nonSpaceCount: number }
  ).wordBreaks

  const result = wordBreaks.reduce(
    (acc, wbrIndex) => {
      acc.result.push(label.slice(acc.lastIndex, wbrIndex))
      acc.result.push(<wbr key={wbrIndex} />)
      acc.lastIndex = wbrIndex
      return acc
    },
    { lastIndex: 0, result: [] } as { lastIndex: number; result: React.ReactNode[] }
  ).result

  result.push(label.slice(wordBreaks[wordBreaks.length - 1] || 0))
  return result
}
